<template>
  <div class="user-wrp-comments mydorm-galeri">
    <file-upload
      class="btn btn-primary"
      post-action="/upload/post"
      extensions="gif,jpg,jpeg,png,webp"
      accept="image/png,image/gif,image/jpeg,image/webp"
      :multiple="true"
      :size="1024 * 1024 * 10"
      v-model="images"
      @input-filter="inputFilter"
      @input-file="inputFile"
    >
      <i class="fa fa-plus"></i>
      Resim Seç
    </file-upload>
    <div class="galeri-wrp">
      <div class="row">
        <div class="col-xs-12 col-md-12">
          <div class="galeri-left-wrp">
            <div
              class="galeri-left__item"
              :class="{ active: item.isActive }"
              v-for="(item, index) in gallery"
              :key="item.id"
              @click="doActive(item, index)"
            >
              <img class="galeri-left__item-img" :src="item.url" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="galeri-wrp__bottom">
        Seçilen Kapak Fotoğrafı
      </div>
    </div>
    <modal
      :active="showModal"
      modal-class="modal-gallery room-gallery"
      @onModalClose="closeGallery"
      :button-group="true"
    >
      <template #button>
        <v-button
          icon="icon-delete"
          class="ssi-button"
          icon-position="left"
          alt="Resimi Sil"
          @click.native="removeItem"
        />
      </template>
      <div slot="content">
        <draggable v-model="images">
          <transition-group tag="div" class="modal-gallery__list" name="fade">
            <div
              v-for="(img, index) in gallery"
              :key="img.id"
              class="modal-gallery__item"
              :class="{ active: index === currentItem }"
              v-show="index === currentItem"
            >
              <img :src="img.url" alt="" class="modal-gallery__img" />
            </div>
          </transition-group>
        </draggable>
        <v-button
          class="green modal-gallery__button prev"
          icon="icon-arrow-left"
          icon-position="left"
          @click.native="prevItem"
          v-if="images.length > 1 && currentItem !== 0"
        />
        <v-button
          class="green modal-gallery__button next"
          icon="icon-arrow-right"
          icon-position="left"
          @click.native="nextItem"
          v-if="images.length > 1 && currentItem !== gallery.length - 1"
        />
      </div>
    </modal>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component'
import draggable from 'vuedraggable'
export default {
  name: 'MyDormGaleri2',
  components: {
    FileUpload,
    draggable
  },
  props: {
    gallery: Array
  },
  emits: ['delete', 'update'],
  data() {
    return {
      currentItem: null,
      showModal: false,
      isActive: false
    }
  },
  computed: {
    images: {
      get() {
        return this.gallery
      },
      set(value) {
        this.$emit('update', value)
      }
    }
  },
  methods: {
    openGallery(index) {
      this.showModal = true
      this.currentItem = index
    },
    closeGallery() {
      this.showModal = false
    },
    prevItem() {
      if (this.currentItem > 0) {
        this.currentItem--
      } else {
        this.currentItem = this.gallery.length - 1
      }
    },
    nextItem() {
      if (this.currentItem < this.gallery.length - 1) {
        this.currentItem++
      } else {
        this.currentItem = 0
      }
    },
    removeItem() {
      const image = this.images[this.currentItem]
      this.images = this.images.filter(
        (item, index) => index !== this.currentItem
      )
      this.$emit('delete', image)
      this.showModal = false
    },
    doActive(item, index) {
      this.currentItem = index
      item.isActive = true
      this.showModal = true
    },
    inputFile(obj) {
      if (!obj.file) return
      obj.url = URL.createObjectURL(obj.file)
    },
    inputFilter(...params) {}
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/components/mydorm-galeri';
</style>
